﻿export default class WorkplaceService {

    getUrl(city,query) {
        return `/api/cities/${city}/workplaces?query=${query}`;
    }

    getCities() {
        const url = "/api/cities/getall";

        return $.ajax({
            url: url
        });
    }

    getWorkplaces(city, query) {
        const url = this.getUrl(city, query);

        return $.ajax({
            url: url
        });
    }

};